import { Component, EventEmitter, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { ExampleFlatNode } from 'src/typings';
import { FolderService } from '../folder.service';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss']
})
export class CreateComponent {
  constructor(private fb: UntypedFormBuilder, private folderService: FolderService) {}

  private _folder: ExampleFlatNode | undefined;

  loading: boolean = false;

  @Input() set folder(folder: ExampleFlatNode | undefined) {
    if (!folder) return;
    this._folder = folder;
    this.folderForm.controls.description.setValue(folder.name);
  }

  get folder() {
    return this._folder;
  }

  @Input() parent_folder: ExampleFlatNode | undefined;

  resultEvent: EventEmitter<boolean> = new EventEmitter();

  folderForm: UntypedFormGroup = this.fb.group({
    description: new UntypedFormControl()
  });

  save() {
    if (this.folder) return this.update();
    return this.create();
  }

  async create() {
    this.loading = true;
    try {
      await firstValueFrom(
        this.folderService.create({
          parentFolderId: this.parent_folder?.id || undefined,
          description: this.folderForm.value.description
        })
      );
    } catch (err) {
      console.error(err);
    }
    this.resultEvent.emit(true);
    this.loading = false;
  }

  async update() {
    if (!this.folder) return;
    this.loading = true;
    try {
      await firstValueFrom(
        this.folderService.updateFolder({
          id: this.folder.id,
          description: this.folderForm.value.description
        })
      );
    } catch (err) {
      console.error(err);
    }
    this.resultEvent.emit(true);
    this.loading = false;
  }
}
